import type { CountryCode } from "libphonenumber-js";

import { Container, Text } from "@mantine/core";

import { ScheduleCallbackForm } from "./ScheduleCallbackForm";
import styles from "./ScheduleCallbackForm.module.css";

interface ScheduleCallbackPanelProps {
    onBackClick?: () => void;
    afterSubmitClickDefault?: () => void;
    shouldShowActions?: boolean;
    isInternationalPhoneEnabled: boolean;
    defaultCountry: CountryCode;
}

export function ScheduleCallbackPanel({
    onBackClick,
    afterSubmitClickDefault,
    shouldShowActions = true,
    isInternationalPhoneEnabled,
    defaultCountry,
}: ScheduleCallbackPanelProps) {
    return (
        <Container
            p="lg"
            pt="sm"
            bg="var(--exwo-color-control-bar-bg)"
            classNames={{ root: styles.scheduleCallbackFormContainer }}
        >
            <Text size="sm" mb="sm">
                Schedule Callback
            </Text>
            <ScheduleCallbackForm
                shouldShowActions={shouldShowActions}
                afterSubmitClickDefault={afterSubmitClickDefault}
                onBackClick={onBackClick}
                isInternationalPhoneEnabled={isInternationalPhoneEnabled}
                defaultCountry={defaultCountry}
            />
        </Container>
    );
}
